import { createContext } from 'react';

export function createNamedContext(name, initialValue) {
  const context = createContext(initialValue || null);
  context.displayName = name;

  return context;
}
